import { useMemo } from 'react';

import { BoardFertilization, BoardStatus } from 'features/Croptimizer/types';
import { unMaskInput } from 'utils/helpers';

interface Props {
  boardStatusValues: BoardStatus | null;
  fertilizationValues: BoardFertilization | null;
  getY1CurrentLoss: string;
  getY2CurrentLoss: string;
  getY3CurrentLoss: string;
  getY4CurrentLoss: string;
  getY5CurrentLoss: string;
}

const useNpkLoss = ({
  fertilizationValues,
  boardStatusValues,
  getY1CurrentLoss,
  getY2CurrentLoss,
  getY3CurrentLoss,
  getY4CurrentLoss,
  getY5CurrentLoss,
}: Props) => {
  const getY1NpkLoss = useMemo(() => {
    if (fertilizationValues && getY1CurrentLoss && boardStatusValues) {
      const lossesPriceN = Number(unMaskInput(fertilizationValues?.nprice));
      const lossesKgN = Number(unMaskInput(fertilizationValues?.nvalue));
      const d9 = () => {
        if (Number(getY1CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (30 * Number(getY1CurrentLoss) - 95) / 100;
          const right =
            1 - (30 * Number(boardStatusValues?.targetPh) - 95) / 100;

          return left - right;
        } else {
          const left = 1 - (30 * Number(getY1CurrentLoss) - 95) / 100;
          const right = 1 - (30 * 6.5 - 95) / 100;

          return left - right;
        }
      };
      const d10 = lossesKgN * lossesPriceN * Number(d9().toFixed(3));

      const lossesPriceK = Number(unMaskInput(fertilizationValues?.kprice));
      const lossesKgK = Number(unMaskInput(fertilizationValues?.kvalue));
      const d17 = () => {
        if (Number(getY1CurrentLoss) > 6) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.001) {
          const left = 1 - (40 * Number(getY1CurrentLoss) - 140) / 100;
          const right =
            1 - (40 * Number(boardStatusValues?.targetPh) - 140) / 100;

          return left - right;
        } else {
          const left = 1 - (40 * Number(getY1CurrentLoss) - 140) / 100;
          const right = 1 - (40 * 6 - 140) / 100;

          return left - right;
        }
      };
      const d18 = lossesKgK * lossesPriceK * Number(d17().toFixed(3));

      const lossesPriceP = Number(unMaskInput(fertilizationValues?.pprice));
      const lossesKgP = Number(unMaskInput(fertilizationValues?.pvalue));
      const d13 = () => {
        if (Number(getY1CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (35 * Number(getY1CurrentLoss) - 127.5) / 100;
          const right =
            1 - (35 * Number(boardStatusValues?.targetPh) - 127.5) / 100;

          return left - right;
        } else {
          const left = 1 - (35 * Number(getY1CurrentLoss) - 127.5) / 100;
          const right = 1 - (35 * 6.5 - 127.5) / 100;

          return left - right;
        }
      };
      const d14 = lossesKgP * lossesPriceP * Number(d13().toFixed(3));

      return Math.round(d10 + d18 + d14);
    }

    return;
  }, [fertilizationValues, getY1CurrentLoss, boardStatusValues?.targetPh]);

  const getY2NpkLoss = useMemo(() => {
    if (fertilizationValues && getY2CurrentLoss && boardStatusValues) {
      const lossesPriceN = Number(unMaskInput(fertilizationValues?.nprice));
      const lossesKgN = Number(unMaskInput(fertilizationValues?.nvalue));
      const d9 = () => {
        if (Number(getY2CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (30 * Number(getY2CurrentLoss) - 95) / 100;
          const right =
            1 - (30 * Number(boardStatusValues?.targetPh) - 95) / 100;

          return left - right;
        } else {
          const left = 1 - (30 * Number(getY2CurrentLoss) - 95) / 100;
          const right = 1 - (30 * 6.5 - 95) / 100;

          return left - right;
        }
      };
      const d10 = lossesKgN * lossesPriceN * Number(d9().toFixed(3));

      const lossesPriceK = Number(unMaskInput(fertilizationValues?.kprice));
      const lossesKgK = Number(unMaskInput(fertilizationValues?.kvalue));
      const d17 = () => {
        if (Number(getY2CurrentLoss) > 6) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.001) {
          const left = 1 - (40 * Number(getY2CurrentLoss) - 140) / 100;
          const right =
            1 - (40 * Number(boardStatusValues?.targetPh) - 140) / 100;

          return left - right;
        } else {
          const left = 1 - (40 * Number(getY2CurrentLoss) - 140) / 100;
          const right = 1 - (40 * 6 - 140) / 100;

          return left - right;
        }
      };
      const d18 = lossesKgK * lossesPriceK * Number(d17().toFixed(3));

      const lossesPriceP = Number(unMaskInput(fertilizationValues?.pprice));
      const lossesKgP = Number(unMaskInput(fertilizationValues?.pvalue));
      const d13 = () => {
        if (Number(getY2CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (35 * Number(getY2CurrentLoss) - 127.5) / 100;
          const right =
            1 - (35 * Number(boardStatusValues?.targetPh) - 127.5) / 100;

          return left - right;
        } else {
          const left = 1 - (35 * Number(getY2CurrentLoss) - 127.5) / 100;
          const right = 1 - (35 * 6.5 - 127.5) / 100;

          return left - right;
        }
      };
      const d14 = lossesKgP * lossesPriceP * Number(d13().toFixed(3));

      return Math.round(d10 + d18 + d14);
    }

    return;
  }, [fertilizationValues, getY2CurrentLoss, boardStatusValues?.targetPh]);

  const getY3NpkLoss = useMemo(() => {
    if (fertilizationValues && getY3CurrentLoss && boardStatusValues) {
      const lossesPriceN = Number(unMaskInput(fertilizationValues?.nprice));
      const lossesKgN = Number(unMaskInput(fertilizationValues?.nvalue));
      const d9 = () => {
        if (Number(getY3CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (30 * Number(getY3CurrentLoss) - 95) / 100;
          const right =
            1 - (30 * Number(boardStatusValues?.targetPh) - 95) / 100;

          return left - right;
        } else {
          const left = 1 - (30 * Number(getY3CurrentLoss) - 95) / 100;
          const right = 1 - (30 * 6.5 - 95) / 100;

          return left - right;
        }
      };
      const d10 = lossesKgN * lossesPriceN * Number(d9().toFixed(3));

      const lossesPriceK = Number(unMaskInput(fertilizationValues?.kprice));
      const lossesKgK = Number(unMaskInput(fertilizationValues?.kvalue));
      const d17 = () => {
        if (Number(getY3CurrentLoss) > 6) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.001) {
          const left = 1 - (40 * Number(getY3CurrentLoss) - 140) / 100;
          const right =
            1 - (40 * Number(boardStatusValues?.targetPh) - 140) / 100;

          return left - right;
        } else {
          const left = 1 - (40 * Number(getY3CurrentLoss) - 140) / 100;
          const right = 1 - (40 * 6 - 140) / 100;

          return left - right;
        }
      };
      const d18 = lossesKgK * lossesPriceK * Number(d17().toFixed(3));

      const lossesPriceP = Number(unMaskInput(fertilizationValues?.pprice));
      const lossesKgP = Number(unMaskInput(fertilizationValues?.pvalue));
      const d13 = () => {
        if (Number(getY3CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (35 * Number(getY3CurrentLoss) - 127.5) / 100;
          const right =
            1 - (35 * Number(boardStatusValues?.targetPh) - 127.5) / 100;

          return left - right;
        } else {
          const left = 1 - (35 * Number(getY3CurrentLoss) - 127.5) / 100;
          const right = 1 - (35 * 6.5 - 127.5) / 100;

          return left - right;
        }
      };
      const d14 = lossesKgP * lossesPriceP * Number(d13().toFixed(3));

      return Math.round(d10 + d18 + d14);
    }

    return;
  }, [fertilizationValues, getY3CurrentLoss, boardStatusValues?.targetPh]);

  const getY4NpkLoss = useMemo(() => {
    if (fertilizationValues && getY4CurrentLoss && boardStatusValues) {
      const lossesPriceN = Number(unMaskInput(fertilizationValues?.nprice));
      const lossesKgN = Number(unMaskInput(fertilizationValues?.nvalue));
      const d9 = () => {
        if (Number(getY4CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (30 * Number(getY4CurrentLoss) - 95) / 100;
          const right =
            1 - (30 * Number(boardStatusValues?.targetPh) - 95) / 100;

          return left - right;
        } else {
          const left = 1 - (30 * Number(getY4CurrentLoss) - 95) / 100;
          const right = 1 - (30 * 6.5 - 95) / 100;

          return left - right;
        }
      };
      const d10 = lossesKgN * lossesPriceN * Number(d9().toFixed(3));

      const lossesPriceK = Number(unMaskInput(fertilizationValues?.kprice));
      const lossesKgK = Number(unMaskInput(fertilizationValues?.kvalue));
      const d17 = () => {
        if (Number(getY4CurrentLoss) > 6) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.001) {
          const left = 1 - (40 * Number(getY4CurrentLoss) - 140) / 100;
          const right =
            1 - (40 * Number(boardStatusValues?.targetPh) - 140) / 100;

          return left - right;
        } else {
          const left = 1 - (40 * Number(getY4CurrentLoss) - 140) / 100;
          const right = 1 - (40 * 6 - 140) / 100;

          return left - right;
        }
      };
      const d18 = lossesKgK * lossesPriceK * Number(d17().toFixed(3));

      const lossesPriceP = Number(unMaskInput(fertilizationValues?.pprice));
      const lossesKgP = Number(unMaskInput(fertilizationValues?.pvalue));
      const d13 = () => {
        if (Number(getY4CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (35 * Number(getY4CurrentLoss) - 127.5) / 100;
          const right =
            1 - (35 * Number(boardStatusValues?.targetPh) - 127.5) / 100;

          return left - right;
        } else {
          const left = 1 - (35 * Number(getY4CurrentLoss) - 127.5) / 100;
          const right = 1 - (35 * 6.5 - 127.5) / 100;

          return left - right;
        }
      };
      const d14 = lossesKgP * lossesPriceP * Number(d13().toFixed(3));

      return Math.round(d10 + d18 + d14);
    }

    return;
  }, [fertilizationValues, getY4CurrentLoss, boardStatusValues?.targetPh]);

  const getY5NpkLoss = useMemo(() => {
    if (fertilizationValues && getY5CurrentLoss && boardStatusValues) {
      const lossesPriceN = Number(unMaskInput(fertilizationValues?.nprice));
      const lossesKgN = Number(unMaskInput(fertilizationValues?.nvalue));
      const d9 = () => {
        if (Number(getY5CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (30 * Number(getY5CurrentLoss) - 95) / 100;
          const right =
            1 - (30 * Number(boardStatusValues?.targetPh) - 95) / 100;

          return left - right;
        } else {
          const left = 1 - (30 * Number(getY5CurrentLoss) - 95) / 100;
          const right = 1 - (30 * 6.5 - 95) / 100;

          return left - right;
        }
      };
      const d10 = lossesKgN * lossesPriceN * Number(d9().toFixed(3));

      const lossesPriceK = Number(unMaskInput(fertilizationValues?.kprice));
      const lossesKgK = Number(unMaskInput(fertilizationValues?.kvalue));
      const d17 = () => {
        if (Number(getY5CurrentLoss) > 6) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.001) {
          const left = 1 - (40 * Number(getY5CurrentLoss) - 140) / 100;
          const right =
            1 - (40 * Number(boardStatusValues?.targetPh) - 140) / 100;

          return left - right;
        } else {
          const left = 1 - (40 * Number(getY5CurrentLoss) - 140) / 100;
          const right = 1 - (40 * 6 - 140) / 100;

          return left - right;
        }
      };
      const d18 = lossesKgK * lossesPriceK * Number(d17().toFixed(3));

      const lossesPriceP = Number(unMaskInput(fertilizationValues?.pprice));
      const lossesKgP = Number(unMaskInput(fertilizationValues?.pvalue));
      const d13 = () => {
        if (Number(getY5CurrentLoss) > 6.5) {
          return 0;
        } else if (Number(boardStatusValues?.targetPh) < 6.501) {
          const left = 1 - (35 * Number(getY5CurrentLoss) - 127.5) / 100;
          const right =
            1 - (35 * Number(boardStatusValues?.targetPh) - 127.5) / 100;

          return left - right;
        } else {
          const left = 1 - (35 * Number(getY5CurrentLoss) - 127.5) / 100;
          const right = 1 - (35 * 6.5 - 127.5) / 100;

          return left - right;
        }
      };
      const d14 = lossesKgP * lossesPriceP * Number(d13().toFixed(3));

      return Math.round(d10 + d18 + d14);
    }

    return;
  }, [fertilizationValues, getY5CurrentLoss, boardStatusValues?.targetPh]);

  const totalNpKLoss = useMemo(() => {
    if (
      getY1NpkLoss &&
      getY2NpkLoss &&
      getY3NpkLoss &&
      getY4NpkLoss &&
      getY5NpkLoss
    ) {
      return (
        getY1NpkLoss + getY2NpkLoss + getY3NpkLoss + getY4NpkLoss + getY5NpkLoss
      );
    }

    return;
  }, [getY1NpkLoss, getY2NpkLoss, getY3NpkLoss, getY4NpkLoss, getY5NpkLoss]);

  return {
    getY1NpkLoss,
    getY2NpkLoss,
    getY3NpkLoss,
    getY4NpkLoss,
    getY5NpkLoss,
    totalNpKLoss,
  };
};

export default useNpkLoss;
